export default "__VITE_ASSET__CMaPGziB__"